import type { ReactNode } from "react";
import { cn } from "../helpers/class-names";

export function Loading({
  children = "Loading…",
  className,
}: {
  children?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("ui-loading", className)}>
      <span />
      {children}
    </div>
  );
}
